import React from 'react';

import urlBuilder from '../../Shared/url-builder';
import { Header } from '../BettermentForAdvisors/Header';

export const ClientBillingHeader: React.FC = () => {
  const CLIENT_BILLING_NAV: {
    label: string;
    to: string;
    isExact: boolean;
    shouldReloadDocument?: boolean;
  }[] = [
    {
      label: 'Billing plans',
      to: urlBuilder.getBillingPlanIndexPage.absolutePath,
      isExact: true,
    },
    {
      label: 'On-demand billing',
      to: urlBuilder.getOnDemandBillingIndexPage.absolutePath,
      isExact: true,
    },
  ];

  return (
    <Header
      title="Client billing"
      navigation={CLIENT_BILLING_NAV}
      css={{
        bg: 'background.surface',
        pt: 'space.400',
        display: 'flex',
        flexDirection: 'column',
        gap: 'space.200',
      }}
    />
  );
};
